import { useEffect, useState } from "react";
import { serviceGetAllProducts } from "../api/serviceApi";
import { toast } from "react-toastify";

export const useProducts = (enabled = true) => {
    const [products, setProducts] = useState([]);
    const [loadingProducts, setLoadingProducts] = useState(false);

    useEffect(() => {
        if (!enabled) {
            return;
        }

        let cancelled = false;

        const loadProducts = async () => {
            try {
                setLoadingProducts(true);

                const result = await serviceGetAllProducts();

                if (!cancelled) {
                    setProducts(
                        Array.isArray(result)
                            ? result.filter((product) => product?.active !== false)
                            : []
                    );
                }
            } catch (error) {
                console.error("Error loading products: ", error);
                if (!cancelled) {
                    setProducts([]);
                    toast.error(error?.message || "Failed to load products");
                }
            } finally {
                if (!cancelled) {
                    setLoadingProducts(false);
                }
            }
        };

        loadProducts();

        return () => {
            cancelled = true;
        }
    }, [enabled]);

    return { products, loadingProducts };
}